import styled from "@emotion/styled";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { logos } from "../../data";
import { theDead } from "../Team";

const ScoresWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const TeamDiv = styled.div`
  display: flex;
  img {
    height: 85px;
    width: 85px;
    margin-bottom: 20px;
  }
  h1 {
    margin: 0;
  }
  p {
    border: 1px solid;
    margin: 5px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 190px;
    border-radius: 5px;
    cursor: pointer;
    transition: opacity 500ms;
    &:hover {
      transition: opacity 500ms;
      opacity: 0.2;
    }
  }
`;

export function Scores({ scores, bracketPoints }) {
  // const thePTs = useRecoilValue(playerTeams);
  // console.log("PTS", thePTs);
  console.log("🚨", bracketPoints);
  const hist = useHistory();
  // return null;
  if (!scores) return;
  return (
    <ScoresWrap>
      <h1>Scores</h1>
      <TeamDiv>
        {scores.standings.map((t) => {
          let totalAlive = 0;
          // console.log(t.teamName)

          scores[t.teamName].forEach((p) => {
            if (!theDead.includes(p.data.person.fullName)) totalAlive++;
            // console.log(!theDead.includes(p.data.person.fullName))
          });
          // console.log(totalAlive)

          return (
            <p
              onClick={() => hist.push(`/${t.teamName}`)}
              key={`score-${t.teamName}`}
            >
              <img src={logos[t.teamName]} alt="team-logo" />{" "}
              <span style={{ fontSize: "32px", fontWeight: "bold" }}>
                {t.score + bracketPoints[t.teamName]}
              </span>
              <span>🏆️ {bracketPoints[t.teamName]}</span>
            </p>
          );
        })}
      </TeamDiv>
    </ScoresWrap>
  );
}
